export default "__VITE_ASSET__BovMdqrz__"